import React from 'react';
import {useSelector} from 'react-redux';

import {GALinkStatus} from '../../../../../../../../../../util/uiconstants';
import Utility from '../../../../../../../../../../util/utilityfunctions';

import {OutputText} from '@ey/canvascoreservices';
import {IconoirSend} from '@ey-xd/motif-icon';

import Button from '../../../../../../../../../Common/BaseComponentWrappers/MotifButton';
import IconButton from '../../../../../../../../../Common/BaseComponentWrappers/MotifIconButton';
import Tooltip from '../../Tooltip';
import StyledStatusLink from './StyledStatusLink';

const StatusLink = ({item, onClick, tooltipText, labels, altProps}) => {
	const canManageGroups = useSelector(({userPreferences}) => userPreferences?.permissions?.canManageGroup);

	const showAsResend = [GALinkStatus.Rejected];

	let buttonLabel = labels.send;
	let Component = IconButton;
	let icon = IconoirSend;

	if (showAsResend.includes(item.linkRequest)) {
		buttonLabel = labels.resend;
		Component = Button;
		icon = false;
	}

	if (
		item.linkRequest === GALinkStatus.InvalidPointOfContact ||
		item.linkRequest === GALinkStatus.NoPointOfContact ||
		((item.linkRequest === GALinkStatus.NotSent || item.linkRequest === GALinkStatus.Rejected) &&
			(item.pocGui === null || item.pocText === null))
	) {
		Component = Button;
	}

	const isDisabled = !canManageGroups || item.isCopiedComponent;

	const buttonProps = {
		type: 'button',
		variant: 'text-alt',
		className: 'send-link-request',
		showLabel: true,
		buttonLabel,
		disabled: isDisabled
	};

	if (onClick) buttonProps.onClick = () => onClick(item);
	if (icon) buttonProps.iconSource = icon;
	if (altProps) altProps.disabled = isDisabled;

	const trigger = (
		<StyledStatusLink disabled={isDisabled}>
			<Component {...(altProps ? altProps : buttonProps)} />
			{altProps?.extraText && (
				<OutputText body2 light>
					{altProps.extraText}
				</OutputText>
			)}
		</StyledStatusLink>
	);

	const tooltipProps = {
		placement: 'bottom',
		trigger,
		hideCloseButton: true,
		allowClick: false
	};

	if (item.isCopiedComponent)
		return (
			<Tooltip {...tooltipProps}>
				<OutputText body2 light>
					{Utility.createRichTextElement(labels.sendLinkDisableTooltip)}
				</OutputText>
			</Tooltip>
		);

	if (
		!canManageGroups ||
		item.linkRequest === GALinkStatus.InvalidPointOfContact ||
		item.linkRequest === GALinkStatus.NoPointOfContact
	)
		return (
			<Tooltip {...tooltipProps}>
				<OutputText body2 light>
					{Utility.createRichTextElement(tooltipText)}
				</OutputText>
			</Tooltip>
		);

	return trigger;
};

export default StatusLink;
